import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { userActions } from '../_actions';
import { userConstants } from '../_constants';

function Application() {
    const entitlements = useSelector(state => state.entitlements);
    const user = useSelector(state => state.authentication.user);
    const efpPartner = useSelector(state => state.authentication.user.efpPartners)
	const dispatch = useDispatch();
	
	const appUser  = useSelector(state => state.user);


	/* for testing: https://efp.nyser.qa.intcx.net */
	
	  /* for the first time before useeffect runs, we are injecting an empty summary so it will not redener everytime, instead just change the summary values when useeffect runs */
	//const version = Object.keys(appUser).length === 0  ? { "version": "0.0.0"} : appUser.version.version;
	const version = localStorage.getItem('version');

      { /* dispatch the entitlment request right after login successful */ }
    useEffect(() => {
        dispatch(userActions.getEntitlements(user.shortName));
    }, []);


	function downloadCS2Specs() {
		dispatch(userActions.downloadCS2Specs(user.shortName));
	}

    function renderApplications(efpApp, efpPartner) {
    	let appRoleView;
    	
  
    	if (efpApp.applicationACCRole === userConstants.DB_CS2_SPECS) {  
    		appRoleView = <div><img src={efpApp.applicationIconUrl} onClick={downloadCS2Specs} /><h3>{ efpApp.applicationName }</h3></div>
        	
    	} else if (efpApp.applicationACCRole === userConstants.DB_NEW_RULE134_ADMIN || efpApp.applicationACCRole === userConstants.DB_NEW_RULE134_USERS
    			|| efpApp.applicationACCRole === userConstants.DB_CS2PLUS_USERS_LEGACY ) {
    		appRoleView = <div><a href={efpApp.applicationOpenUrl} target="_blank"><img src={efpApp.applicationIconUrl} /> </a>
   			<h3>{efpApp.applicationName}</h3>
   			</div>

    	} else if (efpApp.applicationACCRole === userConstants.DB_WEB_CS2PLUS_USERS ) {
    		appRoleView = <div><a href={efpApp.applicationOpenUrl} ><img src={efpApp.applicationIconUrl} /> </a>
   			<h3>{efpApp.applicationName}</h3>
   			</div>
        	
    	} else if (efpApp.applicationACCRole === userConstants.DB_DMMEC_ADMIN || efpApp.applicationACCRole === userConstants.DB_DMMEC_USERS ) {
    		appRoleView = <div>
	    		<form name="myRedirectForm" action="/DMMECClient/redirect/account" method="post" target="_blank">
			    <input name="username" type="hidden" value= { user.shortName } />
			    <input name="fullName" type="hidden" value= { user.fullName } />
			    <input name="jwtToken" type="hidden" value= { user.loginToken } />
			    <input name="version" type="hidden" value=	{ version } />
			    <input name="groupName" type="hidden" value= { efpApp.applicationACCRole } />
			    <input name="bpLinkey" type="hidden" value=  { efpPartner.bpLinkey } />
																		  
			    <input name="bpCompanyName" type="hidden" value= { efpPartner.bpCompanyName } />
			   
			    <button type="submit">
			    	<img src= { efpApp.applicationIconUrl }></img>
			    </button>
			    
			    </form>
		    <h3> { efpApp.applicationName }</h3>
		    </div>
    	} else {
    		appRoleView = <div><a href={efpApp.applicationOpenUrl} ><img src={efpApp.applicationIconUrl}  target="_blank" /> </a>
   			<h3>{efpApp.applicationName}</h3>
   			</div>
    	} 
    	
    	return appRoleView;
    }


    return (
        <div className="container-fluid">
			<div className="row-app_header">
				<div className="col-md-8"> <h3>Entitled Applications</h3> </div>

					{ user.accountStatus &&
						<div className="card bg-danger text-white w-100"> {user.accountStatus} </div>
						
						 }
			
				
			</div>

            {entitlements.loading && <em>Loading entitlements...</em>}
            {entitlements.error && <span className="text-danger">ERROR: {entitlements.error}</span>}
            
            {entitlements.items &&
            	
                <table className="table">
					<tbody>
					<tr>
                    {entitlements.items.map((applications, index) =>
                        <td  key={index}>
                            { applications.efpApplicationsList.map((efpApplication) => 
                            		renderApplications(efpApplication, efpPartner)
                            )}
                        </td>
                    )}
					</tr>
					</tbody>
                </table>
            }
        </div>
    );
}

export { Application };